/**
  * 保存用户信息模块接口列表
  */

import base from '../base'; // 导入接口域名列表
import axios from '../../request/http'; // 导入http中创建的axios实例

const userApi = {
    SaveUser: `${base.qa}/User/SaveUser`,
    ChangePassword: `${base.qa}/User/ChangePassword`,
    GetUserSpecClassData: `${base.qa}/User/GetUserSpecClassData`,//获取用户专业树形图
    UpdateUserInfo: `${base.qa}/User/UpdateUserInfo`,
    UploadFaceImg: `${base.qa}/User/UploadFaceImg`,
    GetUserInfo: `${base.qa}/User/GetUserInfo`,//获取用户信息
}

const user = {
    SaveUser (params) {
        return axios.post(userApi.SaveUser, params)
    },
    ChangePassword (params) {
        return axios.post(userApi.ChangePassword, params)
    },
    GetUserSpecClassData (userid) {
        return axios.get(userApi.GetUserSpecClassData, { params: { userid } })
    },
    UpdateUserInfo (params) {
        return axios.post(userApi.UpdateUserInfo, params)
    },
    UploadFaceImg (params) {
        return axios.post(userApi.UploadFaceImg, params)
    },
    GetUserInfo (params) {
        return axios.get(userApi.GetUserInfo, { params: { userid: params } })
    },
}


export default user;